import Footer from "../footer";
import Header from "../header";
import Card from '../card';

import webDesignImage from '../../images/cardpageimages/technicalcourse/webdesingimage.jpg'
import fullStackImage  from '../../images/cardpageimages/technicalcourse/fullstackwebdevelopment.jpg'
import meanStackImage from '../../images/cardpageimages/technicalcourse/meanstack.jpg'
import mernStackImage from '../../images/cardpageimages/technicalcourse/mernstackimage.jpg'
import computerNetworkingImage  from '../../images/cardpageimages/technicalcourse/networking.jpg'
import mongodbImage from '../../images/cardpageimages/technicalcourse/databaseMangaementImage.jpg'
import  coreJavaImage from '../../images/cardpageimages/technicalcourse/javaimage.jpg'
import pythonImage from '../../images/cardpageimages/technicalcourse/python.jpg'
import  cLanguageImage from '../../images/cardpageimages/technicalcourse/clanguage.png'
import cppImage from '../../images/cardpageimages/technicalcourse/cpp.png'
import dsaWithCppImage from '../../images/cardpageimages/technicalcourse/dsawithcpp.jpg'
import javascriptImage from '../../images/cardpageimages/technicalcourse/javasctiptimage.png'
import reactImage from '../../images/cardpageimages/technicalcourse/reactimage.png'
import  bootstrapImage from '../../images/cardpageimages/technicalcourse/bootstrapimage.png'


function TechnicalCourse(){
     return(<>
             <Header/>
             <div className="container-fluid py-4 bg-gray">
                <div className="container">
                        <h2 className="text-center">Have Look On Our Technical Courses</h2>
                    <div className="row d-md-flex d-block justify-content-evenly">
                        {/* First Row - Always Visible */}
                        <div className="col-md-3 mt-0 mt-sm-3">
                        <Card
                            title="WEB DESIGN"
                            navigateurl="/webdesign"
                            text="Learn to craft beautiful and user-friendly websites that engage visitors."
                            image={webDesignImage}
                        />
                        </div>
                        <div className="col-md-3 mt-0 mt-sm-3">
                        <Card
                            title="FULL STACK DEVELOPMENT"
                            navigateurl="/webdevelopment"
                            text="Build dynamic web applications by mastering frontend and backend skills."
                            image={fullStackImage}
                        />
                        </div>
                        <div className="col-md-3 mt-0 mt-sm-3">
                        <Card
                            title="MERN STACK"
                            navigateurl="/mernstack"
                            text="Create powerful applications using MongoDB, Express.js, React, Node.js."
                            image={mernStackImage}
                        />
                        </div>
                        <div className="col-md-3 mt-0 mt-sm-3">
                        <Card
                        title="DSA with C++"
                        navigateurl="/dsawithcpp"
                        text=" Learn Data Structures and Algorithms with C++ for enhanced coding skills."
                        image={dsaWithCppImage}
                    />
                        </div>
                    </div>

                    {/* Second Row - All Cards Displayed */}
                    <div className="row d-block d-md-flex justify-content-evenly mt-3">
                        <div className="col-md-3 mt-0 mt-sm-3">
                        <Card
                            title="JAVA PROGRAMMING"
                            navigateurl="/java"
                            text="Learn the fundamentals of Java for building robust and scalable applications."
                            image={coreJavaImage}
                        />
                        </div>
                        <div className="col-md-3 mt-0 mt-sm-3">
                        <Card
                            title="MEAN STACK"
                            navigateurl="/meanstack"
                            text="Some quick Develop full-stack applications with MongoDB, Express.js, Angular, and Node.js."
                            image={meanStackImage}
                        />
                        </div>
                        <div className="col-md-3 mt-0 mt-sm-3">
                        <Card
                            title="COMPUTER NETWORKING"
                            navigateurl="/networking"
                            text="Understand networking fundamentals to design and manage effective networks."
                           
                            image={computerNetworkingImage}
                        />
                        </div>
                        <div className="col-md-3 mt-0 mt-sm-3">
                        <Card
                            title="DATABASE MANAGEMENT "
                            navigateurl="/databasemanagement"
                            text="Gain skills in managing and optimizing databases for efficient data handling."
                            image={mongodbImage}
                        />
                        </div>
                    </div>

                      {/* 3rd row - All Cards Displayed */}
                      <div className="row d-block d-md-flex justify-content-evenly mt-3">
                        <div className="col-md-3 mt-0 mt-sm-3">
                        <Card
                            title="PYTHON"
                            navigateurl="/python"
                            text="Master programming concepts and features of Python for versatile applications."
                            image={pythonImage}
                        />
                        </div>
                        <div className="col-md-3 mt-0 mt-sm-3">
                        <Card
                            title="C LANGUAGE"
                            navigateurl="/c"
                            text="Master fundamental programming concepts and features of the C language for efficient applications."
                           
                            image={cLanguageImage}
                        />
                        </div>
                        <div className="col-md-3 mt-0 mt-sm-3">
                        <Card
                            title="C++ LANGUAGE"
                            text="Learn essential programming concepts and features of C++ for high-performance applications."
                            navigateurl="/cpp"
                            image={cppImage}
                        />
                        </div>
                        <div className="col-md-3 mt-0 mt-sm-3">
                        <Card
                            title="JAVASCRIPT FULL COURSE"
                            navigateurl="/javascript"
                            text=" Unlock JavaScript's power to create interactive and dynamic web experiences."
                           
                            image={javascriptImage}
                        />
                        </div>
                    </div>

                      {/* 4th row - All Cards Displayed */}
                      <div className="row d-block d-md-flex justify-content-evenly mt-3">
                        <div className="col-md-3 mt-0 mt-sm-3">
                        <Card
                            title="REACT"
                            navigateurl="/react"
                            text="Master React for building dynamic user interfaces and single-page applications."
                           
                            image={reactImage}
                        />
                        </div>
                        <div className="col-md-3 mt-0 mt-sm-3">
                        <Card
                            title="BOOTSTRAP"
                            navigateurl="/bootstrap"
                            text="Design responsive websites quickly using the powerful Bootstrap framework"
                          
                            image={bootstrapImage}
                        />
                        </div>
                        <div className="col-md-3 mt-0 mt-sm-3">
                        {/* <Card
                            title="Bootstrap"
                            navigateurl="/bootstrap"
                            text="Design responsive websites quickly using the powerful Bootstrap framework"
                          
                            image={bootstrapimage}
                        /> */}
                        </div>
                        <div className="col-md-3 mt-0 mt-sm-3">
                    {/* <Card
                        title="DSA with C++"
                        navigateurl="/dsacpp"
                        text=" Learn Data Structures and Algorithms with C++ for enhanced coding skills."
                        image={dsa}
                    /> */}
                        </div>
                    </div>
                </div>
            </div>
             <Footer/>
     </>);
}

export default TechnicalCourse;
